import { environment } from './../environments/environment';
import { ErrorHandler } from '@angular/core';

export class CustomErrorHandler implements ErrorHandler {

  handleError(error) {
    // do something with the exception
    if (!environment.production) {
      console.log(error.toString());
      //alert(error);
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/custom-error-handler.ts